// Eastern Time (America/New_York) date helpers. The whole app pins
// "today" / "this month" to ET so users in any browser timezone — and
// server functions running in UTC — agree with what the household sees
// on the wall clock. Uses Intl with the IANA zone so DST is handled
// automatically (no fixed -4 / -5 offsets).

const ET_DATE = new Intl.DateTimeFormat('en-CA', {
  timeZone: 'America/New_York',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
});

// 'YYYY-MM-DD' in Eastern Time. en-CA emits ISO-shaped output natively.
export function todayEt(): string {
  return ET_DATE.format(new Date());
}

// 'YYYY-MM' month-key in Eastern Time.
export function currentEtMonthKey(): string {
  return todayEt().slice(0, 7);
}

// 1-12 ET month, for code that just needs the month number.
export function currentEtMonth(): number {
  return Number(todayEt().slice(5, 7));
}
